module.exports = __webpack_public_path__ + "static/media/08_azure-burnaby.564c87b6.jpg";